// Names for common symbols. Falls back to "Cool Symbol U+XXXX" for unknown ones.
// Keys are the symbol characters themselves.
export const SYMBOL_NAMES: Record<string, string> = {
  // Hearts
  "♥": "Black Heart Suit",
  "♡": "White Heart Suit",
  "❤": "Heavy Black Heart",
  "❣": "Heavy Heart Exclamation",
  "❥": "Rotated Heavy Black Heart Bullet",
  "❦": "Floral Heart",
  "❧": "Rotated Floral Heart",
  "💕": "Two Hearts",
  "💖": "Sparkling Heart",
  "💗": "Growing Heart",
  "💘": "Heart with Arrow",
  "💙": "Blue Heart",
  "💚": "Green Heart",
  "💛": "Yellow Heart",
  "💜": "Purple Heart",
  "🖤": "Black Heart",
  "🤍": "White Heart",
  "🤎": "Brown Heart",
  "💝": "Heart with Ribbon",
  "💞": "Revolving Hearts",
  "💟": "Heart Decoration",
  "ღ": "Georgian Letter Ghan (Heart)",
  // Stars
  "★": "Black Star",
  "☆": "White Star",
  "✦": "Black Four Pointed Star",
  "✧": "White Four Pointed Star",
  "✩": "Stress Outlined White Star",
  "✪": "Circled White Star",
  "✫": "Open Centre Black Star",
  "✬": "Black Centre White Star",
  "✭": "Outlined Black Star",
  "✮": "Heavy Outlined Black Star",
  "✯": "Pinwheel Star",
  "✰": "Shadowed White Star",
  "⋆": "Star Operator",
  "✴": "Eight Pointed Black Star",
  "✶": "Six Pointed Black Star",
  "✷": "Eight Pointed Pinwheel Star",
  "✸": "Heavy Eight Pointed Black Star",
  "✹": "Twelve Pointed Black Star",
  "✺": "Sixteen Pointed Asterisk",
  "❅": "Tight Trifoliate Snowflake",
  "❆": "Heavy Chevron Snowflake",
  "⭐": "White Medium Star",
  "🌟": "Glowing Star",
  "✨": "Sparkles",
  "💫": "Dizzy Symbol",
  "🌠": "Shooting Star",
  // Arrows
  "←": "Leftwards Arrow",
  "↑": "Upwards Arrow",
  "→": "Rightwards Arrow",
  "↓": "Downwards Arrow",
  "↖": "North West Arrow",
  "↗": "North East Arrow",
  "↘": "South East Arrow",
  "↙": "South West Arrow",
  "↔": "Left Right Arrow",
  "↕": "Up Down Arrow",
  "⇐": "Leftwards Double Arrow",
  "⇑": "Upwards Double Arrow",
  "⇒": "Rightwards Double Arrow",
  "⇓": "Downwards Double Arrow",
  "⇔": "Left Right Double Arrow",
  "⟵": "Long Leftwards Arrow",
  "⟶": "Long Rightwards Arrow",
  "⟷": "Long Left Right Arrow",
  "➔": "Heavy Wide Headed Rightwards Arrow",
  "➜": "Heavy Round Tipped Rightwards Arrow",
  "➝": "Triangle Headed Rightwards Arrow",
  "➞": "Heavy Triangle Headed Rightwards Arrow",
  "➟": "Dashed Triangle Headed Rightwards Arrow",
  "➠": "Heavy Dashed Triangle Headed Rightwards Arrow",
  "➤": "Black Rightwards Arrowhead",
  // Math
  "+": "Plus Sign",
  "−": "Minus Sign",
  "×": "Multiplication Sign",
  "÷": "Division Sign",
  "±": "Plus-Minus Sign",
  "∓": "Minus-Plus Sign",
  "=": "Equals Sign",
  "≠": "Not Equal To",
  "≈": "Almost Equal To",
  "≡": "Identical To",
  "≤": "Less-Than or Equal To",
  "≥": "Greater-Than or Equal To",
  "∞": "Infinity",
  "∑": "N-Ary Summation",
  "∏": "N-Ary Product",
  "∫": "Integral",
  "∮": "Contour Integral",
  "∂": "Partial Differential",
  "∇": "Nabla",
  "√": "Square Root",
  "∛": "Cube Root",
  "∜": "Fourth Root",
  "∝": "Proportional To",
  "∠": "Angle",
  "⊥": "Up Tack (Perpendicular)",
  "∥": "Parallel To",
  "∈": "Element Of",
  "∉": "Not an Element Of",
  "⊂": "Subset Of",
  "⊃": "Superset Of",
  "⊆": "Subset Of or Equal To",
  "⊇": "Superset Of or Equal To",
  "∪": "Union",
  "∩": "Intersection",
  "∅": "Empty Set",
  "∀": "For All",
  "∃": "There Exists",
  "¬": "Not Sign",
  "∧": "Logical And",
  "∨": "Logical Or",
  "⊕": "Circled Plus",
  "⊗": "Circled Times",
  "π": "Greek Small Letter Pi",
  "τ": "Greek Small Letter Tau",
  "φ": "Greek Small Letter Phi",
  "θ": "Greek Small Letter Theta",
  "λ": "Greek Small Letter Lamda",
  "μ": "Greek Small Letter Mu",
  "σ": "Greek Small Letter Sigma",
  "Σ": "Greek Capital Letter Sigma",
  "Δ": "Greek Capital Letter Delta",
  "Ω": "Greek Capital Letter Omega",
  // Currency
  "$": "Dollar Sign",
  "€": "Euro Sign",
  "£": "Pound Sign",
  "¥": "Yen Sign",
  "₩": "Won Sign",
  "₹": "Indian Rupee Sign",
  "₽": "Ruble Sign",
  "¢": "Cent Sign",
  "₿": "Bitcoin Sign",
  "₣": "French Franc Sign",
  "₤": "Lira Sign",
  "₦": "Naira Sign",
  "₨": "Rupee Sign",
  "₪": "New Sheqel Sign",
  "₫": "Dong Sign",
  "₭": "Kip Sign",
  "₮": "Tugrik Sign",
  "₱": "Peso Sign",
  "₴": "Hryvnia Sign",
  "₵": "Cedi Sign",
  "₸": "Tenge Sign",
  "₺": "Turkish Lira Sign",
  "₼": "Manat Sign",
  "₾": "Lari Sign",
  // Punctuation
  "…": "Horizontal Ellipsis",
  "–": "En Dash",
  "—": "Em Dash",
  "•": "Bullet",
  "·": "Middle Dot",
  "‣": "Triangular Bullet",
  "※": "Reference Mark",
  "‼": "Double Exclamation Mark",
  "⁇": "Double Question Mark",
  "⁈": "Question Exclamation Mark",
  "⁉": "Exclamation Question Mark",
  "‽": "Interrobang",
  "¶": "Pilcrow Sign",
  "§": "Section Sign",
  "✓": "Check Mark",
  "✔": "Heavy Check Mark",
  "✕": "Multiplication X",
  "✖": "Heavy Multiplication X",
  "✗": "Ballot X",
  "✘": "Heavy Ballot X",
  // Shapes
  "■": "Black Square",
  "□": "White Square",
  "●": "Black Circle",
  "○": "White Circle",
  "◉": "Fisheye",
  "◎": "Bullseye",
  "◆": "Black Diamond",
  "◇": "White Diamond",
  "◈": "White Diamond Containing Black Small Diamond",
  "△": "White Up-Pointing Triangle",
  "▲": "Black Up-Pointing Triangle",
  "▽": "White Down-Pointing Triangle",
  "▼": "Black Down-Pointing Triangle",
  "◀": "Black Left-Pointing Triangle",
  "▶": "Black Right-Pointing Triangle",
  "⬡": "White Hexagon",
  "⬢": "Black Hexagon",
  // Zodiac
  "♈": "Aries",
  "♉": "Taurus",
  "♊": "Gemini",
  "♋": "Cancer",
  "♌": "Leo",
  "♍": "Virgo",
  "♎": "Libra",
  "♏": "Scorpio",
  "♐": "Sagittarius",
  "♑": "Capricorn",
  "♒": "Aquarius",
  "♓": "Pisces",
  "⛎": "Ophiuchus",
  "☉": "Sun",
  "☽": "First Quarter Moon",
  "☿": "Mercury",
  "♀": "Venus / Female Sign",
  "♂": "Mars / Male Sign",
  "♃": "Jupiter",
  "♄": "Saturn",
  "♅": "Uranus",
  "♆": "Neptune",
  "♇": "Pluto",
  // Chess & cards
  "♔": "White Chess King",
  "♕": "White Chess Queen",
  "♖": "White Chess Rook",
  "♗": "White Chess Bishop",
  "♘": "White Chess Knight",
  "♙": "White Chess Pawn",
  "♚": "Black Chess King",
  "♛": "Black Chess Queen",
  "♜": "Black Chess Rook",
  "♝": "Black Chess Bishop",
  "♞": "Black Chess Knight",
  "♟": "Black Chess Pawn",
  "♠": "Black Spade Suit",
  "♣": "Black Club Suit",
  "♦": "Black Diamond Suit",
  "♤": "White Spade Suit",
  "♧": "White Club Suit",
  "♢": "White Diamond Suit",
  // Music
  "♩": "Quarter Note",
  "♪": "Eighth Note",
  "♫": "Beamed Eighth Notes",
  "♬": "Beamed Sixteenth Notes",
  "♭": "Music Flat Sign",
  "♮": "Music Natural Sign",
  "♯": "Music Sharp Sign",
  // Weather
  "☀": "Black Sun with Rays",
  "☁": "Cloud",
  "☂": "Umbrella",
  "☃": "Snowman",
  "☄": "Comet",
  "♨": "Hot Springs",
  "❄": "Snowflake",
  "☔": "Umbrella with Rain Drops",
  "⚡": "High Voltage Sign",
  "🌈": "Rainbow",
  "🔥": "Fire",
  "💧": "Droplet",
  // Tech / UI
  "⌘": "Place of Interest (Command)",
  "⌥": "Option Key",
  "⇧": "Upwards White Arrow (Shift)",
  "⌃": "Up Arrowhead (Control)",
  "⎋": "Broken Circle with Northwest Arrow (Escape)",
  "⏎": "Return Symbol",
  "⌫": "Erase to the Left (Backspace)",
  "⌦": "Erase to the Right (Delete)",
  "⇪": "Upwards White Arrow Lock (Caps Lock)",
  "⇥": "Rightwards Arrow to Bar (Tab)",
  "⏏": "Eject Symbol",
  "⌚": "Watch",
  "⌨": "Keyboard",
  "☎": "Black Telephone",
  "✈": "Airplane",
  "✉": "Envelope",
  "✎": "Lower Right Pencil",
  "✏": "Pencil",
  "✒": "Black Nib",
  "⚙": "Gear",
  "♻": "Universal Recycling Symbol",
  "⏻": "Power Symbol",
  "⏰": "Alarm Clock",
};

import { SYMBOL_NAME_MAP, FALLBACK_NAME_SYMBOLS } from "./symbol-name-map.generated";

// Use the lightweight char->name map (NOT the full SymbolRecord index) so this
// module — imported by nearly every UI component — doesn't drag the 1.28 MB
// registry into the client bundle.
const FALLBACK_NAME_SET = new Set(FALLBACK_NAME_SYMBOLS);

// Name precedence:
//   1. Canonical Unicode Character Database name from the generated index
//      (real UCD data, title-cased).
//   2. Curated SYMBOL_NAMES above — only used when UCD has no name for the
//      sequence (e.g. some emoji ZWJ sequences) or to override an awkward UCD
//      label with a friendlier curated one.
//   3. Codepoint-only label as a final fallback.
export function getSymbolName(s: string): string {
  const mapped = SYMBOL_NAME_MAP[s];
  if (mapped && !FALLBACK_NAME_SET.has(s)) return mapped;
  if (SYMBOL_NAMES[s]) return SYMBOL_NAMES[s];
  if (mapped) return mapped;
  return `Symbol ${codepointLabel(s)}`;
}

export function codepointLabel(s: string): string {
  return Array.from(s)
    .map((c) => `U+${c.codePointAt(0)!.toString(16).toUpperCase().padStart(4, "0")}`)
    .join(" ");
}
